import Proxy from './Proxy';

class MailDomainProxy extends Proxy
{
    constructor( parameters = {})
    {
        super( 'api/mail', parameters );
    }
}

export default MailDomainProxy;
